

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function () {
    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
});

_squid.$util;


//////////////////
// WEBPACK FOOTER
// ./js/lib/security.js
// module id = ./js/lib/security.js
// module chunks = 0